import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M11.5 12a.5 .5 0 1 0 1 0a.5 .5 0 1 0 -1 0","fill":"currentColor","key":"svg-0"}],["path",{"d":"M5 12a7 7 0 1 0 14 0a7 7 0 1 0 -14 0","key":"svg-1"}],["path",{"d":"M12 3l0 2","key":"svg-2"}],["path",{"d":"M3 12l2 0","key":"svg-3"}],["path",{"d":"M12 19l0 2","key":"svg-4"}],["path",{"d":"M19 12l2 0","key":"svg-5"}]]

const IconFocus2 = createReactComponent('outline', 'focus-2', 'Focus2', __iconNode);

export default IconFocus2;